<template>
  <span :class="classes">
    <slot></slot>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  variant?: 'default' | 'price'
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'default',
})

const classes = computed(() => {
  return {
    'ui-chip': true,
    [`ui-chip--${props.variant}`]: !!props.variant,
    [`${props.class}`]: !!props.class,
  }
})
</script>

<style scoped lang="scss">
@import '../styles/config';

.ui-chip {
  display: inline-flex;
  padding: 0.375rem 0.5rem;
  font-family: $font-barlow;
  font-size: 0.625rem;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0.1em;
  text-align: center;
  text-transform: uppercase;
  color: $black;
  background-color: $tint-blue;
  border-radius: 1.25rem;

  @include media-breakpoint-up(md) {
    padding: 0.375rem 0.625rem;
    font-size: 0.875rem;
    line-height: 1.28571429;
  }
}

.ui-chip--price {
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1;
  letter-spacing: normal;
  background-color: $tint-orange;

  @include media-breakpoint-up(md) {
    font-size: 1.125rem;
  }
}
</style>
